import React, { useEffect, useState } from 'react';

type AlertProps = {
  message: string;
  type?: 'info' | 'success' | 'error' | 'warning';
  onClose?: () => void;
  children?: React.ReactNode;
};

const Alert: React.FC<AlertProps> = ({ message, type = 'info', onClose, children }) => {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setVisible(false);
      onClose?.();
    }, 5000);

    return () => clearTimeout(timer);
  }, [onClose]);

  if (!visible) return null;

  const getColor = () => {
    switch (type) {
      case 'success':
        return 'var(--primary-gradient)';
      case 'error':
        return 'var(--gradient)';
      case 'warning':
        return 'rgba(255, 166, 0, 0.26)';
      default:
        return 'var(--official-gradient)';
    }
  };

  return (
    <div
      style={{
        background: getColor(),
        color: type === 'warning' ? 'black' : 'white',
        padding: '1rem 1.5rem',
        borderRadius: '0.5rem',
        position: 'relative',
        boxShadow: '0 2px 10px rgba(0,0,0,0.2)',
        maxWidth: '400px',
        margin: '1rem auto',
        fontSize: '1rem',
        fontFamily: 'sans-serif',
      }}
    >
      <span>{message}</span>
      {children}
      <button
        onClick={() => {
          setVisible(false);
          onClose?.();
        }}
        style={{
          position: 'absolute',
          top: '0.5rem',
          right: '0.75rem',
          background: 'transparent',
          border: 'none',
          color: 'white',
          fontSize: '1.2rem',
          cursor: 'pointer',
        }}
        aria-label="Close alert"
      >
        &times;
      </button>
    </div>
  );
};

export default Alert;
